var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 67,
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wordpress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#21759B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.32 149.996c0 50.933 29.6 94.948 72.52 115.807L32.46 97.63c-7.138 16.002-11.14 33.712-11.14 52.366zm215.542-6.493c0-15.903-5.712-26.916-10.61-35.488-6.524-10.6-12.638-19.575-12.638-30.174 0-11.827 8.97-22.837 21.608-22.837.57 0 1.11.07 1.667.103-22.895-20.974-53.395-33.78-86.895-33.78-44.953 0-84.503 23.065-107.51 58 3.018.09 5.863.154 8.28.154 13.46 0 34.293-1.634 34.293-1.634 6.935-.41 7.753 9.78.824 10.6 0 0-6.97.82-14.727 1.226l46.858 139.377 28.16-84.456-20.05-54.928c-6.928-.407-13.492-1.227-13.492-1.227-6.933-.407-6.12-11.01.814-10.6 0 0 21.25 1.633 33.894 1.633 13.456 0 34.293-1.633 34.293-1.633 6.94-.408 7.757 9.78.826 10.6 0 0-6.986.82-14.728 1.227l46.5 138.322 12.836-42.89c5.563-17.8 9.796-30.58 9.796-41.598h.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.254 161.252l-38.607 112.185c11.527 3.39 23.718 5.242 36.35 5.242 14.984 0 29.354-2.59 42.73-7.296-.346-.55-.66-1.136-.916-1.773l-39.556-108.358zm110.65-72.992c.553 4.1.866 8.5.866 13.233 0 13.057-2.438 27.736-9.784 46.09l-39.304 113.64c38.254-22.31 63.985-63.754 63.985-111.224.002-22.374-5.712-43.41-15.763-61.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.996.005C67.29.005 0 67.29 0 149.995c0 82.717 67.29 150 149.996 150 82.704 0 150.004-67.283 150.004-150C299.998 67.29 232.7.005 149.996.005zm0 293.115c-78.913 0-143.118-64.206-143.118-143.124C6.878 71.083 71.08 6.883 149.996 6.883c78.91 0 143.112 64.2 143.112 143.113 0 78.918-64.2 143.124-143.112 143.124z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/wordpress.5cfde807c2932e1d0b0fc1f7d1b1e19d.svg";
export { ForwardRef as ReactComponent };